import React from "react";
import PropTypes from "prop-types";
import submit from "submit-form";
import Modal from "../modal-new";
const id = "modal-add-faq";

class AddFaqModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    const { currentFaq = { answer: "", question: "" } } = this.context.locals;
    this.state = {
      question: this.props.isNew ? "" : currentFaq.question,
      answer: this.props.isNew ? "" : currentFaq.answer,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    const { value, name } = event.target;
    this.setState({
      [name]: value,
    });
  }

  handleCancel(e) {
    e.preventDefault();
    submit("/actions/refresh", {
      method: "GET",
      body: { modal: "" },
    });
  }

  render() {
    const { isNew } = this.props;
    const { id = 0 } = this.context.locals.query;
    return (
      <Modal
        name={id}
        key={id}
        className="add-faq-modal"
        title={isNew ? "Create new question" : "Edit Question"}
      >
        <div className="body">
          <div className="Add-Faq">
            <div className="group">
              <label>Question</label>
              <textarea
                name="question"
                className="textarea-input"
                placeholder="Enter your Frecuently asked question here"
                value={this.state.question}
                onChange={(evt) => this.handleInputChange(evt)}
                sz="large"
              />
            </div>
            <div className="group mt-6">
              <label>Answer</label>
              <textarea
                name="answer"
                className="textarea-input"
                placeholder="Answer the question here"
                value={this.state.answer}
                onChange={(evt) => this.handleInputChange(evt)}
                sz="large"
              />
            </div>
          </div>
        </div>
        <footer>
          <a
            role="button"
            data-button-type="secondary"
            data-action="cancel"
            onClick={this.handleCancel}
          >
            Cancel
          </a>
          <button
            type="submit"
            data-button-type="primary"
            onClick={() => {
              submit("#", {
                method: "POST",
                body: {
                  id,
                  isNew,
                  question: this.state.question,
                  answer: this.state.answer,
                },
              });
            }}
          >
            Add question
          </button>
        </footer>
      </Modal>
    );
  }
}

AddFaqModal.contextTypes = { locals: PropTypes.object };

export { id };
export { AddFaqModal as default };
